<template>
  <form class="form" @submit.prevent="onSubmit()">
    <FormGroup :v="v$.phone" label="label.phone">
      <TextField
        v-model="formValue.phone"
        :disabled="props.saving"
        type="tel"
        placeholder="placeholder.phone"
        autocomplete="tel"
      />
    </FormGroup>

    <AppButton type="submit" :loading="props.saving">
      {{ $t("common.continue") }}
    </AppButton>
  </form>
</template>

<script setup lang="ts">
import { computed, reactive } from "vue";
import AppButton from "@/components/app-button.vue";
import FormGroup from "@/components/form/form-group.vue";
import TextField from "@/components/form/text-field.vue";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { PhoneData } from "@/types";
import { phone } from "@/utils/validators";

const props = defineProps<{
  saving?: boolean;
}>();

const emit = defineEmits<{
  (e: "submit", v: PhoneData): void;
}>();

const formValue = reactive({
  phone: "",
});

const rules = computed(() => ({
  phone: { required, phone },
}));

const v$ = useVuelidate(rules, formValue);

const onSubmit = () => {
  v$.value.$touch();

  if (!v$.value.$invalid) {
    emit("submit", { ...formValue });
  }
};
</script>
